import React from "react";
/**
 * The small help text under the input element
 * 
 * @param {*} param0 
 * @returns 
 */
export default function HelpText({ children }) {

    return (
        <small className="d-block mb-1 form-text text-muted">{children}</small>
    );
}
